import { withInstall } from '@bigin/utils'

import Image from './src/image.vue'

export const BImage = withInstall(Image)
export default BImage

export * from './src/image'
